/**
 * Optima: textos de navegación y UI en español cuando el menú o el tema vienen en inglés.
 */
const OPTIMA_ES_NAV = {
  Home: 'Inicio',
  Catalog: 'Catálogo',
  Contact: 'Contacto',
  Search: 'Buscar',
  Account: 'Cuenta',
  Cart: 'Carrito',
};

function optimaTranslateNav(root = document) {
  const links = root.querySelectorAll(
    '#header-component a, #header-component button, .menu-drawer a, .header__menu a'
  );

  for (const el of links) {
    const text = el.textContent?.trim();
    if (!text || !(text in OPTIMA_ES_NAV)) continue;
    el.textContent = OPTIMA_ES_NAV[text];
  }
}

function initOptimaLocale() {
  optimaTranslateNav();
}

if (document.documentElement.classList.contains('optima-theme')) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOptimaLocale, { once: true });
  } else {
    initOptimaLocale();
  }

  document.addEventListener('shopify:section:load', () => {
    optimaTranslateNav();
  });
}
